// import React, { createContext, useState, useContext } from 'react';

// const AuthContext = createContext();

// export const useAuth = () => {
//   return useContext(AuthContext);
// };
// const BASE_URL = process.env.REACT_APP_BASE_URL;

// export const AuthProvider = ({ children }) => {
//   const [isLoggedIn, setIsLoggedIn] = useState(() => {
//     return sessionStorage.getItem('isLoggedIn') === 'true';
//   });

//   // const login = async (user_name, password) => {
//   //   const fetchUser = async () => {
//   //     try {
//   //       const response = await fetch(`http://localhost:3449/api/users/login`, {
//   //         method: "POST",
//   //         headers: {
//   //           "Content-Type": "application/json",
//   //         },
//   //         body: JSON.stringify({ user_name, password }),
//   //         credentials: 'include' // Include credentials in the request
//   //       });
//   //       return response.json();
//   //     } catch (error) {
//   //       console.error("Error fetching user:", error);
//   //       return { error: "Server Error" };
//   //     }
//   //   };
//   //   const result = await fetchUser();
//   //   console.log(result);
//   //   if (result && result.message === "Login successful") {
//   //     setIsLoggedIn(true);
//   //     sessionStorage.setItem("isLoggedIn", "true");
//   //     return true;
//   //   } else {
//   //     setIsLoggedIn(false);
//   //     return false;
//   //   }
//   // };


//   const login = async (user_name, password) => {
//     // Helper function to decode a JWT token
//     const decodeToken = (token) => {
//       try {
//         // Split the token into its parts and decode the payload
//         const payloadBase64 = token.split('.')[1];
//         const payloadJson = atob(payloadBase64);
//         return JSON.parse(payloadJson);
//       } catch (error) {
//         console.error("Error decoding token:", error);
//         return null;
//       }
//     };

//     const fetchUser = async () => {
//       try {
//         const response = await fetch(`${BASE_URL}/users/login`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ user_name, password }),
//           credentials: 'include' // Include credentials in the request if needed
//         });
//         return response.json();
//       } catch (error) {
//         console.error("Error fetching user:", error);
//         return { error: "Server Error" };
//       }
//     };

//     const result = await fetchUser();
//     console.log(result);

//     if (result && result.message === "Login successful") {
//       setIsLoggedIn(true);
//       sessionStorage.setItem("isLoggedIn", "true");
//       return true;
//     } else {
//       setIsLoggedIn(false);
//       return false;
//     }
//   };



//   const logout = () => {
//     setIsLoggedIn(false);
//     sessionStorage.removeItem('isLoggedIn'); // Remove login state from session storage
//   };

//   return (
//     <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };


// import React, { createContext, useState, useContext } from "react";
// import Cookies from "js-cookie";

// const AuthContext = createContext();

// export const useAuth = () => useContext(AuthContext);

// const BASE_URL = process.env.REACT_APP_BASE_URL;

// export const AuthProvider = ({ children }) => {
//   // Initialize isLoggedIn from sessionStorage
//   const [isLoggedIn, setIsLoggedIn] = useState(
//     sessionStorage.getItem("isLoggedIn") === "true"
//   );

//   // Initialize user from sessionStorage if available
//   const [user, setUser] = useState(() => {
//     const storedUser = sessionStorage.getItem("user");
//     return storedUser ? JSON.parse(storedUser) : null;
//   });

//   // Decode a JWT token
//   function decodeToken(token) {
//     try {
//       const payloadBase64 = token.split(".")[1];
//       const payloadJson = atob(payloadBase64);
//       return JSON.parse(payloadJson);
//     } catch (error) {
//       console.error("Error decoding token:", error);
//       return null;
//     }
//   }

//   const login = async (user_name, password) => {
//     try {
//       const response = await fetch(`${BASE_URL}/users/login`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ user_name, password }),
//         credentials: "include",
//       });
//       const result = await response.json();

//       // Get token from cookie and decode it
//       const token = Cookies.get("token");
//       const decodedToken = decodeToken(token);
//       console.log("Token from cookie:", decodedToken);
//       console.log("Decoded token:", decodedToken);

//       if (result && result.message === "Login successful") {
//         setIsLoggedIn(true);
//         sessionStorage.setItem("isLoggedIn", "true");
//         sessionStorage.setItem("user", JSON.stringify(decodedToken));
//         setUser(decodedToken);
//         return true;
//       } else {
//         setIsLoggedIn(false);
//         return false;
//       }
//     } catch (error) {
//       console.error("Error during login:", error);
//       return false;
//     }
//   };

//   const logout = () => {
//     setIsLoggedIn(false);
//     setUser(null);
//     sessionStorage.removeItem("isLoggedIn");
//     sessionStorage.removeItem("user");
//   };

//   return (
//     <AuthContext.Provider value={{ isLoggedIn, user, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };


import React, { createContext, useState, useContext, useRef, useEffect } from "react";
import Cookies from "js-cookie";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const AuthProvider = ({ children }) => {
  // Initialize isLoggedIn from sessionStorage
  const [isLoggedIn, setIsLoggedIn] = useState(
    sessionStorage.getItem("isLoggedIn") === "true"
  );

  // Initialize user from sessionStorage if available
  const [user, setUser] = useState(() => {
    const storedUser = sessionStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  // Create a ref to hold the logout timer
  const logoutTimerRef = useRef(null);

  // Decode a JWT token to extract payload (e.g., expiration time)
  function decodeToken(token) {
    try {
      const payloadBase64 = token.split(".")[1];
      const payloadJson = atob(payloadBase64);
      return JSON.parse(payloadJson);
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  }

  // Schedule auto logout based on token expiration time
  const scheduleAutoLogout = (exp) => {
    const currentTime = Math.floor(Date.now() / 1000); // current time in seconds
    const timeUntilExpiry = (exp - currentTime) * 1000; // time until expiry in milliseconds

    if (timeUntilExpiry > 0) {
      logoutTimerRef.current = setTimeout(() => {
        logout();
        console.log("Auto-logged out due to token expiry");
      }, timeUntilExpiry);
    }
  };

  const login = async (user_name, password) => {
    try {
      const response = await fetch(`${BASE_URL}/users/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ user_name, password }),
        credentials: "include",
      });
      const result = await response.json();

      // Get token from cookie and decode it
      const token = Cookies.get("token");
      const decodedToken = decodeToken(token);
      console.log("Token from cookie:", decodedToken);

      if (result && result.message === "Login successful") {
        setIsLoggedIn(true);
        sessionStorage.setItem("isLoggedIn", "true");

        // Store decoded token information (including exp) as the user
        sessionStorage.setItem("user", JSON.stringify(decodedToken));
        setUser(decodedToken);

        // Schedule an auto logout if the token contains an expiration time
        if (decodedToken?.exp) {
          scheduleAutoLogout(decodedToken.exp);
        }

        return true;
      } else {
        setIsLoggedIn(false);
        return false;
      }
    } catch (error) {
      console.error("Error during login:", error);
      return false;
    }
  };

  const logout = () => {
    setIsLoggedIn(false);
    setUser(null);
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("user");

    if (logoutTimerRef.current) {
      clearTimeout(logoutTimerRef.current);
    }
  };

  // When the AuthProvider mounts, if the user is logged in, reschedule the auto logout
  useEffect(() => {
    if (isLoggedIn && user?.exp) {
      scheduleAutoLogout(user.exp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
